import {IHealthcareFacility} from "app/shared/model/healthcare-facility.model";
import {IVehicleType} from "app/shared/model/vehicleType.model";

export interface IAmbulance {
  id?: string;
  driverFirstName?: string;
  driverLastName?: string;
  vehicleType?: IVehicleType;
  phoneNumber?: string;
  healthcareFacilityId?: string;
  phone_number_2?: string;
  phone_number_3?: string;
  active?: boolean;
  healthcareFacility?: IHealthcareFacility;
  neighborHealthcareFacilityIds?: string[];
  mpesaNumber?: string;
}

export const defaultValue: Readonly<IAmbulance> = {};
